import React, { Component } from 'react'

import 'react-dates/initialize'
import { DayPickerRangeController } from 'react-dates'

import Modal from 'react-bootstrap-modal'

class ChooseDatesModal extends Component {
  static defaultProps = {
    isOpen: false
  }
  state = {
    focusedInput: 'startDate',
    checked: false,
    flexValue: ''
  }

  validate = evt => {
    const theEvent = evt || window.event
    let key = theEvent.keyCode || theEvent.which
    key = String.fromCharCode(key)
    const regex = /[0-9]/
    if (!regex.test(key)) {
      theEvent.returnValue = false
      if (theEvent.preventDefault) theEvent.preventDefault()
    }
  }

  componentWillMount() {
    if (this.props.startDate && this.props.endDate) {
      this.setState({checked: true})
    }
  }

  render() {
    const { isOpen, onClose } = this.props
    return (
      <Modal show={isOpen} onHide={() => onClose()} dialogClassName="gallery_modal" aria-labelledby="ModalHeader">
        <Modal.Header>
          <Modal.Title>Choose your dates</Modal.Title>
          <i
            className="event-modal__close icon-close"
            onClick={() => {
              onClose()
            }}
          />
        </Modal.Header>
        <Modal.Body>
          <DayPickerRangeController
            numberOfMonths={2}
            startDate={this.props.startDate} // momentPropTypes.momentObj or null,
            endDate={this.props.endDate} // momentPropTypes.momentObj or null,
            onDatesChange={this.props.onDatesChange} // PropTypes.func.isRequired,
            focusedInput={this.state.checked ? null : this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
            onFocusChange={focusedInput =>
              this.setState({ focusedInput: focusedInput ? focusedInput : 'startDate' }, console.log('focus', focusedInput))
            } // PropTypes.func.isRequired,
            hideKeyboardShortcutsPanel={true}
          />
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '3px', marginLeft: '20px' }}>
            <input
              type="checkbox"
              style={{ margin: 0 }}
              checked={this.state.checked}
              onClick={() =>
                this.setState(
                  {
                    checked: !this.state.checked
                  },
                  () => this.props.clearFlex()
                )
              }
            />
            <span style={{ color: '#252f2f', fontSize: '1.6rem', padding: '0 10px' }}>Flexible dates</span>
          </div>
          {this.state.checked && (
            <div style={{ marginLeft: '20px' }}>
              <span style={{ color: '#252f2f', fontSize: '2rem' }}>Number of Days</span>
              <input
                onKeyPress={this.validate}
                value={this.props.flexDays}
                onChange={e => this.props.onFlexChange(e)}
                style={{
                  height: '40px',
                  width: '191px',
                  border: '1px solid #ccdfe8',
                  outline: 'none',
                  color: '#768285',
                  fontSize: '1.6rem',
                  padding: '0 10px',
                  marginLeft: '26px'
                }}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-sm btn-primary btn-danger"
            style={{ float: 'right', height: '48px', width: '271px', fontSize: '20px', borderRadius: '5px' }}
            onClick={() => this.props.onClose()}
          >
            Done
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ChooseDatesModal



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/ChooseDatesModal.jsx